<template>
  <div :class="['definition-wrapper', 'number', definition.id, {'error_validate': mandatoryValidation || validation }]">
    <div v-if="editable">
      <input :placeholder="placeholder" type="text" v-model="textValue" ref="inputText" :name="definition.id" @blur="valueChanged($event)" @keyup="keyPressed($event)" class="w3-input">
    </div>
    <definition-read-only v-else :definitionId="definitionId" :definition="definition" :object="object" :languageSelected="languageSelected" :visualDefinition="visualDefinition" />
  </div>
</template>

<script>
import DefinitionReadOnly from './readOnly'
import transport from 'vue-definition-utils/src/utils/transport'
import moment from 'moment'

export default {
  name: 'definition-number',
  props: [
    'definition',
    'object',
    'definitionObject',
    'editable',
    'mandatoryValidation',
    'languageSelected',
    'definitionId',
    'definitionContentId',
    'repeatableGroupCode',
    'showMultilanguage',
    'requestObjectForAdd',
    'requestObjectForAddModified',
    'language',
    'visualDefinition',
    'apiparams',
    'placeholder',
    'callTask'
  ],
  components: {
    DefinitionReadOnly
  },
  data () {
    return {
      textValue: '',
      validation: null
    }
  },
  methods: {
    // 1.1. Launch validate mandatory event on blur
    valueChanged (event) {
      this.setObjectTextValue()
      this.$emit('validateMandatory', moment().valueOf(), this.object)
    },
    // 1.2. Launch validate mandatory event on Enter pressed
    keyPressed (event) {
      if (event.key === 'Enter') {
        this.$refs.inputText.blur()
        this.valueChanged(event)
      }
    },
    validateNumberFormat () {
      this.validation = transport.methods.validateNumberFormat(transport.methods.isRequired(this.definition), this.definition.validation.format, this.textValue)
      // 3. if text format validation past...
      if (this.validation === null) {
        // ... launch refresh definition event
        this.$emit('refreshDefinition', this.object)
      } else {
        // ... or launch text format error event to show error message
        this.$emit('numberFormatError', moment().valueOf(), this.validation, this.definition.validation.format)
      }
    },
    setObjectTextValue () {
      this.object.textValue = this.textValue
    },
    setNumberValue () {
      if (this.object) {
        this.textValue = this.object.textValue
      }
    }
  },
  beforeMount () {
    this.setNumberValue()
  },
  watch: {
    mandatoryValidation (value) {
      // 2. if mandatory validation past...
      if (value && (value.validateKey === null || value.validateKey.trim() === '')) {
        // ... launch text format validation
        this.validateNumberFormat()
      }
    },
    object (object) {
      this.setNumberValue()
    }
  },
  directives: {
    focus: {
      inserted (el) {
        el.focus()
      }
    }
  }
}
</script>

<style lang="scss">
.definition-wrapper.number {
  word-break: break-all;

  input.w3-input {
    border-radius: 3px;
    background-color: #ffffff;
    border: solid 1px #e8e8e8;
    height: 33px;
    outline: none;
    width: 100%;
  }
  input.w3-input:focus {
    border: solid 1px #b8b8b8;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/content/definitionLoader/item/number.vue